import React from "react";

// ...rest lets BranchBar hand down data-* attributes — the Knowledge Base walkthrough
// anchors to data-tour / data-branch-id without depending on this markup.
const BranchButton = React.forwardRef(({ title, clicked, index, selected, ...rest }, ref) => {
  const [isHovered, setIsHovered] = React.useState(false);

  // The selected pill is rendered as a shared sliding element by BranchBar, so
  // here we only handle the hover highlight for unselected items. Text color
  // still transitions to stay in sync with the sliding pill.
  const background = !selected && isHovered ? "#ECF4FF" : "transparent";

  return (
    <div
      ref={ref}
      {...rest}
      onClick={() => clicked(index)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative z-10 rounded-[17px] px-3 py-[5px] cursor-pointer whitespace-nowrap transition-colors duration-300 ease-in-out"
      style={{ backgroundColor: background }}
    >
      <span
        className={`font-OpenSansMedium text-[14px] transition-colors duration-300 ease-in-out ${
          selected ? "text-white" : "text-titleColor"
        }`}
      >
        {title}
      </span>
    </div>
  );
});

BranchButton.displayName = "BranchButton";

export default BranchButton;
